import ConnectionLostModal from '../utils/ConnectionLost';

const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.170.2.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const config = {
  host: 'sense-demo.qlik.com',
  appId: 'dce1f9fd-9c40-4282-a099-4977533e11e3',
};
const url = SenseUtilities.buildUrl(config);
const session = enigma.create({ schema, url });

session.on('closed', () => {
  console.error('Qlik Sense Session ended!');  //eslint-disable-line
  const refreshUrl = window.location;
  const timeoutMessage = 'Due to inactivity, the app has been paused. Please refresh to continue.';
  ConnectionLostModal({ refreshUrl, timeoutMessage });
});

export default session.open().then((global) => global.openDoc(config.appId));
